import script from "./DataComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./DataComparison.vue?vue&type=script&setup=true&lang=js"

import "./DataComparison.vue?vue&type=style&index=0&id=40812352&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40812352"]])

export default __exports__